<template>
  <!-- vertical-align -->
  <b-button :class="'button-component button--' + $props.variant" :size="$props.size" :to="$props.to" :href="$props.href" :target="$props.target" @click="$emit('click')" :style="''+$props.style">
    <b-img style="height: 1.5em;margin-top:-5px" v-if="$props.image !== undefined" :src="$props.image" role="icon" alt="icon"></b-img>
    <b-icon v-if="$props.icon !== undefined && ($props.iconPosition==='start' || $props.iconPosition=== undefined)" :icon="$props.icon"></b-icon>
    <span class="text ml-1" v-if="$props.text !== undefined && $props.text !== ''" v-html="$props.text"></span>
    <b-icon class="ml-1" v-if="$props.icon !== undefined && $props.iconPosition==='end'" :icon="$props.icon"></b-icon>
    <div class="point"></div>
  </b-button>
</template>
<script>
export default {
  name: 'ButtonComponent',
  props: {
    variant: {
      type: String,
      default: 'gray'
    },
    text: String,
    icon: String,
    image: String,
    href: String,
    iconPosition: String, // start or end
    size: { type: String, default: 'md' },
    to: String,
    target: {
      type: String,
      default: '_self'
    }
  },
  beforeMount () {
    // NOTHING
  }
}
</script>
<style lang="scss" scoped>
  @import "../../variables.scss";
  /** GENERAL STYLES **/
  .button-component {
    margin: 0;
    width: auto;
    border-radius: 3.2rem;
    position:relative;
    padding-left: 1rem;
    padding-right: 1rem;
    vertical-align: middle;
    .text{
      font-size: 1rem;
      min-height: 2rem;
      font-weight: normal;
      text-align: center;
    }
    .icon{
      height: 1.3rem;
      max-height: 1.3rem;
      padding: 0.1rem;
    }
    &:hover {
      box-shadow: 0px 4px 10px #006DF04D;
      .point {
          top: -0.6rem;
          right: -0.6rem;
      }
    }
    &:disabled {
      background-color: $color-light-gray;
      color: $color-black;
      .point{
          background-color: $color-light-gray;
      }
    }
    .point {
      width: 0.7rem;
      min-width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
      position: absolute;
      top: 0.7rem;
      right: 0.7rem;
      transition: all 0.3s;
    }
  }

  .button-component:focus{
    background-color: $color-light-gray;
    color: $color-black;
    .point{
        background-color: $color-light-gray;
    }
  }
  /** PRIMARY VARIANT **/
  .button--primary  {
    border: 0.2rem solid $color-celeste !important;
    background-color: $color-blue !important;
    color: $color-white !important;
    .point{
        background-color: transparent;
    }
    &:hover {
        color:$color-white !important;
        border: 0.2rem solid $color-blue !important;
        background-color: $color-blue--dark !important;
        .point{
          background-color: $color-blue;
        }
    }
  }
  /** PRIMARY VARIANT - SMALL SCREEN **/
  .button--secondary {
    border: 0.2rem solid $color-blue;
    background-color: $color-white;
    color: $color-blue !important;
    .point {
      background-color: transparent;
    }
    &:hover {
      background-color: $color-blue--dark;
      color: $color-white !important;
      border: 0.2rem solid $color-blue;
      .point {
        background-color: $color-blue;
      }
    }
  }
  /** LIGHT VARIANT **/
  .button--light {
    border: 0.2rem solid $color-light-gray !important;
    background-color: $color-white !important;
    color: $color-black !important;
    .point{
        background-color: transparent;
    }
    &:hover {
        color:$color-black !important;
        border: 0.2rem solid $color-gray !important;
        background-color: $color-light-gray !important;
        .point{
          background-color: $color-gray;
        }
    }
  }

  /** DARK VARIANT **/
  .button--dark  {
    border: 0.2rem solid $color-black !important;
    background-color: $color-black--light !important;
    color: $color-white !important;
    .point{
        background-color: transparent;
    }
    &:hover {
        color:$color-white !important;
        border: 0.2rem solid $color-black--light !important;
      background-color: $color-black !important;
        .point{
          background-color: $color-black--light;
        }
    }
  }
  /** INFO VARIANT **/
  .button--info {
      border: 0.2rem solid $color-blue;
      background-color: $color-celeste;
      color: #006DF0;
      .point {
        background-color: transparent;
      }
      &:hover {
        background-color: $color-blue;
        color:$color-white;
        border: 0.2rem solid $color-blue;
        .point {
          opacity: 1;
        }
      }
    }

  /** GRAY VARIANT **/
  .button--gray {
      border: 0.2rem solid $color-gray--dark;
      background-color: $color-gray;
      color: $color-black;
      .point {
          background-color: transparent;
      }

      &:hover {
          background: $color-gray--dark;
          color: $color-gray--light;
          .point {
              background-color: $color-gray--dark;
          }
      }
    }

    /** WARNING VARIANT **/
    .button--warning {
      border: 0.2rem solid $color-yellow--dark !important;
      background-color: $color-yellow !important;
      color: $color-black !important;
      .point{
          background-color: transparent;
      }
      &:hover {
          color:$color-black !important;
          border: 0.2rem solid $color-yellow !important;
          background: $color-yellow--dark !important;
          .point{
            background-color: $color-yellow;
          }
      }
    }

    /** DANGER VARIANT **/
    .button--danger {
      border: 0.2rem solid $color-red--dark !important;
      background-color: $color-red !important;
      color: $color-white !important;
      .point{
          background-color: transparent;
      }
      &:hover {
          color:$color-white !important;
          border: 0.2rem solid $color-red !important;
          background: $color-red--dark !important;
          .point{
            background-color: $color-red;
          }
      }
    }

    /** ORANGE VARIANT **/
    .button--orange {
      border: 0.2rem solid $color-orange--dark !important;
      background-color: $color-orange--light !important;
      color: $color-white !important;
      .point{
          background-color: transparent;
      }
      &:hover {
          color:$color-white !important;
          border: 0.2rem solid $color-orange !important;
          background: $color-orange--dark !important;
          .point{
            background-color: $color-orange--dark;
          }
      }
    }

  /** WARNING LIGHT VARIANT **/
  .button--warning-light {
    border: 0.2rem solid $color-orange !important;
    background-color: $color-yellow--light !important;
    color: $color-black--light !important;
    .point{
        background-color: transparent;
    }
    &:hover {
        color:$color-black !important;
        border: 0.2rem solid $color-orange !important;
        .point{
          background-color: $color-orange;
        }
    }
  }

  /** SUCCESS VARIANT **/
  .button--success {
    border: 0.2rem solid $color-green--dark !important;
    background-color: $color-green-light !important;
    color: $color-green--dark !important;
    .point{
        background-color: transparent;
    }
    &:hover {
        color:$color-green--dark !important;
        border: 0.2rem solid $color-green--dark !important;
        .point{
          background-color: $color-green--dark;
        }
    }
  }

/** FOR SMARTPHONES **/
@media (max-width: 768px) {
   .button-component{
      font-size: 0.8rem;
      margin: 0;
      width: auto;
      border-radius: 3.2rem;
      position:relative;
      padding-left: 0.4rem;
      padding-right: 0.4rem;
      .point {
        display:none;
      }
     .text{
       font-size:0.8rem;
     }
      .icon{
        display:none;
      }
   }
}
/** FOR TABLETS AND IPADS **/
@media (max-width: 1280px) {
  .button-component{
    font-size: 1rem;
    margin: 0;
    width: auto;
    border-radius: 2.2rem;
    position:relative;
    padding-left: 1rem;
    padding-right: 1.4rem;
    .point {
      display:none;
    }
    .text{
      font-size:0.9rem;
    }
    .icon{
      height: 0.6rem;
      display:none;
    }
  }
}
</style>
